import { render, staticRenderFns } from "./SideBarNews.vue?vue&type=template&id=72f881f5&scoped=true"
import script from "./SideBarNews.vue?vue&type=script&lang=js"
export * from "./SideBarNews.vue?vue&type=script&lang=js"
import style0 from "./SideBarNews.vue?vue&type=style&index=0&id=72f881f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f881f5",
  null
  
)

export default component.exports